module.exports = __webpack_public_path__ + "static/media/figtree.8c0a89ea.woff2";